import { InjectionToken, Injector, InputSignal, TemplateRef } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { ScrollFreezeServiceTypes } from '@frontend/sports/common/core/feature/scroll-freeze';
import { ElementProvider } from '@frontend/sports/common/core/utils/element-provider';
import { TrackingType } from '@frontend/sports/tracking/feature';
import { DsButtonKind, DsButtonSize, DsButtonVariant } from '@frontend/ui/button';

export interface IDialogTracking {
    name: string;
    type: TrackingType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
}

export type UnwrapComponentProps<T> = {
    [P in keyof T]: T[P] extends InputSignal<infer U> ? U : T[P];
};

export interface ModalDialogOptions<T> {
    data?: T;
    settings?: DialogSettings;
}

export interface DialogSettings {
    isModalDialog?: boolean;
    isPopup?: boolean;
    showDialogHeader?: boolean;
    hideCloseButton?: boolean;
    title?: string;
    fit?: boolean;
    cssClass?: string;
    showPageHeader?: boolean;
    showBottomNav?: boolean;
    showBackNav?: boolean;
    animation?: DialogAnimation;
    closeAnimation?: DialogAnimation;
    tracking?: IDialogTracking;
    container?: HTMLElement;
    inColumn?: boolean;
    scrollFreezeType?: ScrollFreezeServiceTypes;
    backdropClass?: string;
    afterResulted?: () => void;
    beforeDismiss?: () => boolean | Promise<boolean>;
    scrollTargetQuerySelector?: string;
    closeOnChildPopup?: boolean;
    injector?: Injector;
    epcotShowBalance?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    headerTemplate?: TemplateRef<any>;
    showCloseBtnText?: boolean;
    closePrevious?: boolean;
    needsAuthentication?: boolean;
    animatePopupDismiss?: boolean;
    showCloseIcon?: boolean;
    headerSelector?: string;
    gestures?: boolean;
    gesturesRestorePreviousUrl?: boolean;
}

export enum DialogAnimation {
    SlideInFromBottom = 'SlideInFromBottom',
    SlideInFromRight = 'SlideInFromRight',
    SlideOutFromTop = 'SlideOutFromTop',
}

export interface ContentData {
    type?: DialogType;
    title?: string;
    firstParagraph?: string | SafeHtml;
    secondParagraph?: string | SafeHtml;
    buttons?: DialogButton[];
    showCloseLink?: boolean;
}

export enum DialogType {
    Warning = 'warning',
    Info = 'info',
    Action = 'action',
}

export interface DialogButton {
    text: string;
    type: ButtonType;
    buttonConfig?: {
        kind: DsButtonKind;
        variant: DsButtonVariant;
        size: DsButtonSize;
    };
    cssClass?: string;
}

export enum DialogClosedBy {
    Button,
    CloseLink,
}

export enum ButtonType {
    Ok,
    Cancel,
}

export const MODAL_DIALOG_CONTAINER = new InjectionToken<ElementProvider>('ms-modal-dialog-container');
export const DEFAULT_HEADER_SELECTOR = '#headerWrapper';
